export const HEADER_GROUP = [
    {
        title: "About",
        subTitle: "펜션소개",
        contents: [
            {
                title: "펜션소개",
                path: "/about",
            },
            {
                title: "오시는길",
                path: "/location",
            },
        ],
    },
    {
        title: "Specials",
        subTitle: "부대시설",
        contents: [
            {
                title: "",
                path: "/specials",
            },
        ],
    },
    {
        title: "Rooms",
        subTitle: "객실",
        contents: [
            {
                title: "",
                path: "/rooms",
            },
        ],
    },
    {
        title: "Guide",
        subTitle: "이용안내",
        contents: [
            {
                title: "종합 이용안내",
                path: "/guide",
            },
        ],
    },
    {
        title: "Reservation",
        subTitle: "예약조회",
        contents: [
            {
                title: "예약하기",
                path: "/reserve",
            },
            {
                title: "예약조회",
            },
            {
                title: "여기어때 예약",
            },
        ],
    },
];
